import React, {useCallback, useContext, useEffect, useMemo, useState} from 'react'
import Button from "react-bootstrap/Button";
import {useNavigate} from "@reach/router";
import {HttpContext} from "../../util/hooks/useHttp";
import {MyToastContext} from "../../util/context/MyToastContext";
import {ERROR_TOAST, logger, SUCCESS_TOAST} from "../../util/Util";
import Card from "react-bootstrap/Card";
import {List} from "semantic-ui-react";
import RedditPost from "./RedditPost";
import RedditComment from "./RedditComment";
import CollapsableCard from "../CollapsableCard";
import {TbArrowBack } from "react-icons/tb";
import {SubredditConfigContext} from "../../util/context/SubredditConfigContext";
import {VerifiedAccountsContext} from "../../util/context/VerifiedAccountsContext";
import {Container, Row, Col} from "react-bootstrap";
import { IoMdArrowRoundUp, IoMdArrowRoundDown } from "react-icons/io";
import Loading from "../Loading";
import {ANON_USER, NULL_USER} from "../../App";

/**
 *
 id = 1
 dateStr = "08/17/21"
 username = "TheSox3"
 subreddit = "hiphopheads"
 numberOfDays = 7
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export default function RoundupLabel(props) {
    let roundup = props.roundup;
    let nav = useNavigate();
    const viewRoundup = function () {
        nav(`/roundups/${roundup.id}`)
    };

    var label =(
        <span className={"uppercase"} >
            <span className={"no_wrap"}>{props.text}</span>
        </span>
    )
    return !roundup && !props.text ? (
        <Row className={"roundupNavRow emptyNavRow"}>
            <Col>&nbsp;</Col>
        </Row>
    ) : props.type === "nav" ? (
        <Row className={"roundupNavRow"}>
            {props.suffix && (
                <Col xs={10}>
                    {label} &nbsp;
                </Col>
            )}
            <Col xs={2}>
                <Button variant={"secondary"} className={"roundupNavButton"} onClick={viewRoundup}>
                    {props.prefix}{props.suffix}
                </Button>
            </Col>

            {props.prefix && (
                <Col xs={10}>
                    &nbsp; {label}
                </Col>
            )}
        </Row>
    ) : (
        <div className={"roundupListItem"}>
            <b>{roundup.date}:</b>&nbsp;
            <Button className={"roundupViewButton"} onClick={viewRoundup}>
                <span>
                    {roundup && roundup.numberOfDays === 1 ? 'Daily' : 'Weekly'} roundup
                </span>
            </Button>
        </div>
    )

}

export function ViewRoundup(props) {
    let {userId, loggedIn} = useContext(VerifiedAccountsContext)
    let toastContext = useContext(MyToastContext);
    let nav = useNavigate();
    let roundupId = Number(props.roundupId)
    let httpContext = useContext(HttpContext)
    let {roundupData, setRoundupMeta, setRoundupData} = useContext(SubredditConfigContext);

    let [isLoading, setIsLoading] = useState(false)
    let [isLoadingMeta, setIsLoadingMeta] = useState(false)
    let [prevRoundup, setPrevRoundup] = useState(null)
    let [nextRoundup, setNextRoundup] = useState(null)
    let [prevSub, setPrevSub] = useState(null)
    let [nextSub, setNextSub] = useState(null)

    let [didThisAlready, setDidThisAlready] = useState(null)
    let [loadedId, setLoadedId] = useState(null)

    let thisMeta = useMemo(() => {
        let meta = roundupData.roundups[roundupId]?.meta || {}
        if (!meta?.subreddit && Object.entries(roundupData.metaBySub).length > 0) {
            let meta = Object.entries(roundupData.metaBySub).find(([key, val], indx) => {
                if (val && val.length) {
                    return val.find((m) => m.id + "" === roundupId + "") != null
                }
                return false;
            })
            if (meta?.length) {
                return meta[1].find((m) => m.id + "" === roundupId + "")
            }
        }
        return meta
    }, [roundupData.metaBySub, roundupData.roundups, roundupId])

    let thisRoundup = useMemo(() => {
        return roundupData.roundups[roundupId] || {}
    }, [roundupData.roundups, roundupId])

    useEffect(() => {
        if (roundupId && roundupId !== loadedId) {
            setLoadedId(roundupId);
            if (!thisRoundup.posts) {
                setIsLoading(true)
                httpContext.sendRequest(`/api/roundups/${roundupId}`, "GET")
                    .then((resp) => {
                        setIsLoading(false)
                        logger("/roundups", resp.posts.map(r => r.redditPost))
                        logger("/roundups matchers", resp.matchers)
                        setRoundupData(resp, roundupId)
                    })
                    .catch((resp) => {
                        setIsLoading(false)
                        toastContext.addToast("Error loading roundup id " + roundupId, ERROR_TOAST)
                    })
            }
        }
    }, [httpContext, loadedId, roundupId, setRoundupData, thisRoundup.posts, toastContext]) //ignore toastContext, http

    useEffect(() => {
        if (roundupId && !thisMeta.subreddit && !isLoadingMeta) {
            setIsLoadingMeta(true)
            httpContext.sendRequest(`/api/roundupsMeta/${roundupId}`, "GET")
                .then((resp) => {
                    setRoundupMeta(resp, true)
                    setIsLoadingMeta(false)
                })
                .catch((resp) => {
                    // setIsLoadingMeta(false)
                })
        }
    }, [httpContext, isLoadingMeta, roundupData.loadedMeta, roundupData.roundups, roundupId, setRoundupMeta, thisMeta]) //ignore toastContext, http

    useEffect(() => {
        if ((!didThisAlready || didThisAlready !== roundupId) && roundupData.loadedMeta && thisMeta?.subreddit) {
            setDidThisAlready(roundupId)

            let subRoundups = roundupData.metaBySub[thisMeta.subreddit]
            let thisIndex = subRoundups.findIndex((r) => r.id+""  === roundupId+"")
            if (thisIndex >= 0) {
                let prevRndup = subRoundups[thisIndex-1] || subRoundups[subRoundups.length-1]
                let nextRndup = subRoundups[thisIndex+1] || subRoundups[0]
                if (prevRndup && prevRndup.id+"" !== thisMeta.id+"") {
                    setPrevRoundup(subRoundups[thisIndex-1])
                } else {
                    setPrevRoundup(null)
                }
                if (nextRndup && nextRndup.id+"" !== thisMeta.id+"") {
                    setNextRoundup(subRoundups[thisIndex+1])
                } else {
                    setNextRoundup(null)
                }
            }

            let allSubs = Object.keys(roundupData.metaBySub).sort()
            let thisSubIndex = allSubs.indexOf(thisMeta.subreddit)
            if (thisSubIndex >= 0) {
                let prevSubreddit = allSubs[thisSubIndex-1] || allSubs[allSubs.length-1]
                let nextSubreddit = allSubs[thisSubIndex+1] || allSubs[0]
                if (nextSubreddit && nextSubreddit !== thisMeta.subreddit && roundupData && roundupData.metaBySub[nextSubreddit]) {
                    setNextSub(roundupData.metaBySub[nextSubreddit][0])
                } else {
                    setNextSub(null)
                }
                if (prevSubreddit && prevSubreddit !== thisMeta.subreddit && roundupData && roundupData.metaBySub[prevSubreddit]) {
                    setPrevSub(roundupData.metaBySub[prevSubreddit][0])
                } else {
                    setPrevSub(null)
                }
            }
        }
    }, [didThisAlready, roundupData, roundupData.loadedMeta, roundupData.metaBySub, roundupId, thisMeta])

    let signupForRoundup = useCallback (() => {
        sessionStorage.setItem("roundup_signup", roundupId)
        if (userId !== ANON_USER && userId !== NULL_USER) {
            httpContext.sendRequest("/copyConfig/" + roundupId, "PUT")
                .then(() => {
                    toastContext.addToast("Success", SUCCESS_TOAST)
                })
                .catch((resp) => {
                    if (resp && resp["error"] && resp["error"] === "exists") {
                        toastContext.addToast("You already have a config for this subreddit", ERROR_TOAST)
                    } else {
                        toastContext.addToast("Something went wrong", ERROR_TOAST)
                    }
                })
        } else {
            nav("/welcome/signup")
        }
    }, [httpContext, nav, roundupId, toastContext, userId])

    let isAuthUser = useMemo(() => {
        return userId && loggedIn && thisMeta?.authUserId + "" === userId + ""
    }, [loggedIn, thisMeta?.authUserId, userId])

    return (
        <Card className={"top_level_card roundup_card"}>
            <Card.Header>
                    <Row style={{marginBottom: ".2rem", justifyContent: "space-between"}}>
                        <Col xs={3}>
                            <Button variant={"secondary"}
                                    onClick={() => nav("/")}>
                                <TbArrowBack/> Home
                            </Button>
                        </Col>
                            {!isAuthUser && (
                                <>
                                    <Col xs={4} style={{alignContent: "center"}}>
                                        <b style={{textTransform: "uppercase"}}><span className={"no_wrap"}>{thisMeta.subreddit}</span> {thisMeta.date}</b>
                                    </Col>
                                    <Col xs={4}>
                                        <Button style={{float: "right"}} onClick={signupForRoundup}>Sign up for this roundup</Button>
                                    </Col>
                                </>
                            )}

                    </Row>

                {isAuthUser && (prevRoundup || prevSub || nextRoundup || nextSub) && (
                    <Container fluid className={"nav_wrapper"}>
                        <Row>
                            <Col className={"left_side"}>

                                <RoundupLabel type={"nav"} text={prevSub?.subreddit}
                                                          suffix={<IoMdArrowRoundUp/>}
                                                          roundup={prevSub}/>

                                <Row className={"roundupNavRow thisRoundupNav"}>
                                    <Col xs={8} className={"uppercase"}>
                                        {thisMeta.subreddit}
                                    </Col>
                                    <Col xs={4}/>
                                </Row>

                                <RoundupLabel type={"nav"} text={nextSub?.subreddit}
                                                          suffix={<IoMdArrowRoundDown/>}
                                                          roundup={nextSub}/>
                            </Col>
                            <Col className={"right_side"}>
                                <RoundupLabel type={"nav"} text={prevRoundup?.date}
                                                              suffix={<IoMdArrowRoundUp/>}
                                                              roundup={prevRoundup}/>

                                <Row className={"roundupNavRow thisRoundupNav"}>
                                    <Col xs={8} className={"uppercase"}>
                                        {thisMeta.date}
                                    </Col>
                                    <Col xs={4}/>
                                </Row>

                                <RoundupLabel type={"nav"} text={nextRoundup?.date}
                                                              suffix={<IoMdArrowRoundDown/>}
                                                              roundup={nextRoundup}/>
                            </Col>
                        </Row>
                    </Container>
                )}
            </Card.Header>
            <Card.Body>
                {isLoading && <Loading/>}
                {/*<ListGroup>*/}
                {thisRoundup?.matchers && thisRoundup?.matchers?.map((matcher) => {
                    return (
                        <div key={matcher.id} className={"nested_card"}>
                            <CollapsableCard cardId={"roundup_matcher_" + matcher.id} className={"roundup_matcher"}
                                             body={
                                                 <List>
                                                     {thisRoundup?.posts[matcher.id]
                                                         && thisRoundup?.posts[matcher.id].map((post) => {
                                                         let postId;
                                                         let element;
                                                         if (post.postId) {
                                                             postId = post.postId
                                                             element = <RedditPost post={post}/>
                                                         } else {
                                                             postId = post.commentId
                                                             element = <RedditComment comment={post}/>
                                                         }
                                                         return (
                                                             <List.Item key={postId}>
                                                                 {element}
                                                             </List.Item>
                                                         )
                                                     })}
                                                 </List>}
                                             header={<h3 className={"matcher_title"}>
                                                 {matcher.displayName}</h3>}>

                            </CollapsableCard>
                        </div>
                    )
                })}

            </Card.Body>
        </Card>
    )
}